import React from "react";

import "./details.css"
import AppConfig from "../../config/AppConfig";
import {DateUtils} from "../../utils/dateUtils";
import {DetailsInputTable} from "../../components/Tables/DetailsInputTable";
import {ImpactTable} from "../../components/Tables/ImpactTable";
import Counties from "../../config/CountiesConfig";


export class Details extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            cst: DateUtils.getImpactStartCST(),
            form: this._getDefaultUrlForm()
        }

    }

    formSubmitCallback (form){
        this.setState({form:form});
    }

    _getDefaultUrlForm() {

        const params = new URLSearchParams(window.location.search);

        const countyParam = params.get("county");
        const fuelParam = params.get("fuel");
        const sizeParam = params.get("size");

        const county = Counties.find(
                c => c.name.toLowerCase() === countyParam?.toLowerCase()
        ) || Counties[0];

        return {
            fuel: AppConfig.fuel[fuelParam] || AppConfig.fuel.light,
            county: county,
            size: AppConfig.size[sizeParam] || AppConfig.size.small,
            cst: DateUtils.getImpactStartCST()
        };

    }

    render(){

        document.title = "Kansas Flint Hills Smoke Management - Your Fire Impacts";

        return(
            <div className={"details"}>

                <div className={"details-disclaimer"}>
                    {this.props.i18n.Summary_Disclaimer_P1}
                </div>

                <div className={"details-data-range-container"}>
                    <div className={"details-paragraph"}>
                        {this.props.i18n.Summary_Range_P1}
                        {DateUtils.getStartSeason().format(AppConfig.time.displayDateFormat)}
                        {this.props.i18n.Summary_Range_P2}
                        {DateUtils.getEndSeason().format(AppConfig.time.displayDateFormat)}
                        {this.props.i18n.Summary_Range_P3}
                    </div>

                    <div className={"details-paragraph"}>
                        {this.props.i18n.Summary_Forecast_Update}
                    </div>

                </div>

                <DetailsInputTable
                    i18n={this.props.i18n}
                    formSubmitCallback={this.formSubmitCallback.bind(this)}
                    form={this.state.form}
                    cst={this.state.cst}
                />

                <ImpactTable
                    i18n={this.props.i18n}
                    form={this.state.form}
                />

            </div>
        )
    }

}

